import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import richContentUtils, { checkIfRichText } from '../../utils/richContentUtils';


const DisplayRichContent = ({
  content
  , className = ''
  , openEditor
  , isEditable
  , placeholderText = 'Click to add content'
  , customFontMap
}) => {

  const defaultCustomFontMap = {
    h1: '!text-pf-black-800 text-4xl'
    , h2: '!text-pf-black-800 text-3xl'
    , h3: '!text-pf-black-800 text-2xl'
    , p: `!text-pf-black-800`
    , ol: `!text-pf-black-800`
    , ul: `!text-pf-black-800`
  }
  const hasRichContent = checkIfRichText(content);
  const html = richContentUtils.editorState(content || { blocks: [] }, customFontMap || defaultCustomFontMap);
  return (
    <div className={`w-full h-fit min-h-10 flex flex-row ${className}`}>
      <div className='w-full p-2 rounded'>
        {hasRichContent ? parse(html) : placeholderText}
      </div>
      {!!openEditor && !!isEditable && (
        <div className='w-fit h-full flex -mt-6'>
          <button className="fas fa-edit p-2 text-pf-slate-700" onClick={openEditor} />
        </div>
      )}
    </div>
  )
}

DisplayRichContent.propTypes = {
  content: PropTypes.shape({
    blocks: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired
      , text: PropTypes.string.isRequired
      , type: PropTypes.string.isRequired
      , depth: PropTypes.number.isRequired
      , inlineStyleRanges: PropTypes.arrayOf(PropTypes.shape({
        offset: PropTypes.number.isRequired
        , length: PropTypes.number.isRequired
        , style: PropTypes.string.isRequired
      })).isRequired
      , entityRanges: PropTypes.arrayOf(PropTypes.shape({
        offset: PropTypes.number.isRequired
        , length: PropTypes.number.isRequired
        , key: PropTypes.number.isRequired
      })).isRequired
      , data: PropTypes.object
    })).isRequired
  })
  , className: PropTypes.string
  , openEditor: PropTypes.func
  , isEditable: PropTypes.bool
}

export default DisplayRichContent;
